import * as Yup from 'yup'

import { i18n } from '../../../localization/i18n'

const NAME_REGEX = /^[\p{L}\p{M}][\p{L}\p{M}' -]*$/u
const PHONE_ALLOWED_CHARACTERS_REGEX = /^[+\d\s()-]+$/
const MIN_PHONE_DIGITS = 7
const MAX_PHONE_DIGITS = 15

/**
 * Create a name validation schema for checkout fields.
 * @param requiredKey - i18n key for required message (e.g. 'checkout.validation.firstNameRequired').
 * @param invalidKey - i18n key for invalid characters (uses {{field}}).
 * @param fieldLabel - Field label for interpolation in invalid message.
 */
export const createNameSchema = (requiredKey: string, invalidKey: string, fieldLabel: string) =>
  Yup.string()
    .trim()
    .required(i18n.t(requiredKey))
    .matches(NAME_REGEX, i18n.t(invalidKey, { field: fieldLabel }))

/**
 * Create a phone validation schema for checkout fields.
 * @param isRequired - Whether the phone field is required.
 * @returns A Yup string schema for phone numbers.
 */
export const createPhoneSchema = (isRequired: boolean) => {
  let schema = Yup.string().trim()

  if (isRequired) {
    schema = schema.required(i18n.t('checkout.validation.phoneRequired'))
  }

  return schema
    .test(
      'valid-phone-characters',
      i18n.t('checkout.validation.phoneInvalidCharacters'),
      (value) => !value || PHONE_ALLOWED_CHARACTERS_REGEX.test(value),
    )
    .test('valid-phone-length', i18n.t('checkout.validation.phoneInvalidLength'), (value) => {
      if (!value) {
        return !isRequired
      }

      const digitsOnly = value.replace(/\D/g, '')
      return digitsOnly.length >= MIN_PHONE_DIGITS && digitsOnly.length <= MAX_PHONE_DIGITS
    })
}
